module.exports = __webpack_public_path__ + "static/img/14000399.b6dc56f1.png";